export default "__VITE_ASSET__groGHIAN__"